module.exports = __webpack_public_path__ + "static/media/contactPrologo.28521191.PNG";